import Vue from 'vue';
import PictureViewer from './component/index.vue';

const PictureViewerComponent = Vue.extend(PictureViewer);

const $PictureViewer = {
  show(config) {
    const el = new PictureViewerComponent().$mount();
    el.urls = config.photoUrls;
    el.initialIndex = config.photoPreviewIndex;
    el.value = config.showPhotoPreView;
    el.closeOnClickMask = config.closeOnClickMask;
    el.zIndex = config.zIndex;
    el.initialHeight = config.initialHeight;
    el.initialWidth = config.initialWidth;
    el.infinite = config.infinite;
    document.body.appendChild(el.$el);
  },
};

export default {
  install() {
    if (!Vue.prototype.$PictureViewer) {
      Vue.prototype.$PictureViewer = $PictureViewer;
    }
  },
};
